<div *ngIf="jobAppLoaded">
    <app-navbar appHideBreadcrumb>
        <h2>{{pageTitle}}</h2>

        <!--    <h2>Aplicatie pentru FrontendDeV</h2>-->
    </app-navbar>

    <div class="container">
        <div class="single-application-container">
            <div class="row">
                <div class="col-md-12">
                    <div class="back-buttons">
                        <a class="round-button green-button" routerLink="{{backButtonUrl}}">Inapoi</a>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <div class="single-application-interview">
                        <h4 class="pb-10">Raspunsuri mini-interviu</h4>
                        <div class="pb-4" *ngIf="application.miniInterviewAnswers.question1 !== ''">
                            <p><strong>1. {{application.miniInterviewAnswers.question1}}</strong></p>
                            <p>{{application.miniInterviewAnswers.answer1}}</p>
                        </div>
                        <div class="pb-4" *ngIf="application.miniInterviewAnswers.question2 !== ''">
                            <p><strong>2. {{application.miniInterviewAnswers.question2}}</strong></p>
                            <p>{{application.miniInterviewAnswers.answer2}}</p>
                        </div>
                        <div class="pb-4" *ngIf="application.miniInterviewAnswers.question3 !== ''">
                            <p><strong>3. {{application.miniInterviewAnswers.question3}}</strong></p>
                            <p>{{application.miniInterviewAnswers.answer3}}</p>
                        </div>
                        <div class="pb-4" *ngIf="application.miniInterviewAnswers.question4 !== ''">
                            <p><strong>4. {{application.miniInterviewAnswers.question4}}</strong></p>
                            <p>{{application.miniInterviewAnswers.answer4}}</p>
                        </div>
                        <div class="pb-4" *ngIf="application.miniInterviewAnswers.question5 !== ''">
                            <p><strong>5. {{application.miniInterviewAnswers.question5}}</strong></p>
                            <p>{{application.miniInterviewAnswers.answer5}}</p>
                        </div>

                        <h4 class="pt-10" *ngIf="application.candidateApplicationMessage !== ''">Mesajul tau catre compania angajatoare</h4>
                        <p>{{application.candidateApplicationMessage}}</p>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="single-application-info">
                        <h5>Adresă candidat</h5>
                        <p>{{application.candidateAddress}}</p>

                        <div class="text-center">
                            <a class="round-button blue-background" target="_blank"
                               routerLink="/profil-candidat/{{application.userId}}"> Profilul candidatului</a>
                        </div>


                        <div class="recommandation-container"
                             *ngIf="application.recommendationLetter !== 'string' || application.recommendationLetter === null">
                            <h5>Scrisoare recomandare</h5>
                            <div class="text-center">
                                <a class="round-button blue-background" href="{{application.recommendationLetter}}" target="_blank">Vezi scrisoare</a>
                            </div>
                        </div>

                        <div *ngIf="userRole === 'client' && this.application.statusApplication.interviewDate === null">
                            <hr>
                            <form *ngIf="!interviewIsSet" (ngSubmit)="handleAuthClick(interviewCallDate)"
                                  #interviewCallDate="ngForm">
                                <strong class="m-0" for="interviewDate">Programeaza candidatul la interviu:</strong>

                                <div class="interview-hour-container">
                                    <input type="datetime-local" id="interviewDate" class="form-control"
                                           name="interviewDate" ngModel>
                                </div>

                                <button type="submit"
                                        class="round-button green-background form-control"
                                        [disabled]="!interviewCallDate.valid">
                                        {{'BUTTONS.SEND' | translate}}
                                </button>
                            </form>
                        </div>
                        <div class="text-center" *ngIf="this.application.statusApplication.interviewDate !== null || interviewIsSet">
                            <hr>
                            <p *ngIf="setDate == ''">Data interviului: {{application.statusApplication.interviewDate | date:"MM-dd-yyyy h:mm a"}}</p>
                            <a href="https://meet.google.com/{{application.statusApplication.googleMeetLink}}"
                          target="_blank" class="round-button green-background">Link interviu</a>
                        </div>
                        <div class="app-status" *ngIf="userRole === 'client'">
                            <hr>
                            <strong>Status aplicatie:</strong>
                            <select class="form-control" [(ngModel)]="application.statusApplication.responseStatus" (change)="changeAppStatus($event)">
                                <option value="noAnswerReceived">În așteptare</option>
                                <option value="applicationRejected">Aplicație respinsă</option>
                                <option value="interviewPlanned">Interviu planificat</option>
                            </select>
                        <hr>
                        </div>
                        <div class="app-status" *ngIf="userRole !== 'client'">
                            <hr>
                            <p *ngIf="application.statusApplication.responseStatus === 'noAnswerReceived'"><strong>Status aplicatie:</strong> În așteptare</p>
                            <p *ngIf="application.statusApplication.responseStatus === 'applicationRejected'"><strong>Status aplicatie:</strong> Aplicație respinsă</p>
                            <p *ngIf="application.statusApplication.responseStatus === 'interviewPlanned'"><strong>Status aplicatie:</strong> Interviu planificat</p>
                        </div>

                        <div class="app-comments" *ngIf="userRole === 'client'">
                            <div class="single-comment" *ngFor="let comment of application.applicationMessages">
                                <strong>Postat {{comment.messageDate | date:'dd-MM-yyyy HH:mm:ss'}}</strong>
                                <p>{{comment.message}}</p>
                            </div>
                            <hr>
                            <form (ngSubmit)="sendComment(messageForm)" #messageForm="ngForm">
                                <strong class="card-label font-weight-bolder text-dark">Lasa un comentariu vizibil doar pentru tine</strong>
                                <textarea class="form-control" name="message" ngModel #message="ngModel" maxlength="256"
                                          placeholder="Comentariu" required></textarea>
                                <div class="error-msg"
                                     *ngIf="!message.valid && (message.touched || messageForm.submitted)">Acest
                                    camp este obligatoriu!
                                </div>

                                <button type="submit"
                                        class="send-comment round-button form-control" [disabled]="messageForm.invalid">
                                        {{'BUTTONS.SEND' | translate}}
                                </button>
                                <app-form-message [success]="formResponse" *ngIf="formSent"></app-form-message>
                            </form>
                        </div>
                    </div>
                    <div class="job-info">
                        <h5>Sumar companie si job</h5>

                        <div class="text-center">
                            <a class="round-button blue-background" target="_blank"
                               routerLink="/companii/{{jobDetails.companyId}}"> Profilul companiei</a>
                        </div>


                        <div class="recommandation-container">
                            <h5>Descrierea jobului</h5>
                            <div [innerHtml]="jobDetails.jobDescription"></div>

                        <div class="text-center">
                            <a class="round-button blue-background center"
                                                        routerLink="/job/{{jobDetails.id}}">Vezi jobul</a>
                        </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>
</div>
